import { Grid, Paper } from "@mui/material";
import React from "react";
import "../../Styles/strategy.css";
import HeaderIcons from "../../Images/headericon.png";
import ActivityTable from '../Tables/ActivityTable'

function Index() {

  return (
    <>
      <Grid item xs={12}>
        <Paper
          sx={{ p: 2, display: "flex", flexDirection: "column" }}
          elevation={1}
        >
          <div className="row rows" style={{ marginLeft: "2px" }}>
            <div className="col-1">
              <img src={HeaderIcons} alt="Header Icon" width="45" height="45" />
            </div>
            <div
              className="col-9"
              style={{ marginTop: "10px", marginLeft: "-3%" }}
            >
              <p style={{ fontSize: "20px", color: "#18275A" }}>
                {" "}
                Activity logs
              </p>
            </div>
          </div>
        </Paper>
      </Grid>
      <Grid item xs={12}>
      <div className='row' >
         <div className='col-12' style={{ marginTop: "20px" }}>
         <ActivityTable/>
         </div>
        </div>
      </Grid>
    </>
  );
}

export default Index;